export enum Tenant {
  INTER_RISK = 'interrisk',
  COMPENSA = 'compensa',
  TUW = 'tuw',
}

const isTenant = (value: string): value is Tenant => Object.values(Tenant).includes(value as Tenant);

const normalizedTenant = process.env.REACT_APP_TENANT_NAME?.toLowerCase();

export const TENANT_NAME = normalizedTenant && isTenant(normalizedTenant) ? normalizedTenant : Tenant.COMPENSA;
